export default __webpack_public_path__ + "static/media/669.56434b0a.jpg";